import { Controller } from "@hotwired/stimulus"

// Toggles between download button and spinner when preparing documents.
export default class extends Controller {
  static targets = ["downloadContainer", "spinnerContainer"]

  prepare() {
    this.downloadContainerTarget.style.display = 'none'
    this.spinnerContainerTarget.style.display = ''
  }
}
